var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mb35 p20 brdr-1 brdr-cl-primary bg-cl-white",
      staticStyle: { "border-radius": "30px" }
    },
    [
      _c("div", { staticClass: "row mb15" }, [
        _c(
          "div",
          {
            staticClass: "col-xs-12 col-sm-6",
            class: { "cl-accent": !_vm.isEdited }
          },
          [
            _c("h3", { staticClass: "m0 mb5" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("My shipping details")) +
                  "\n      "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
          !_vm.isEdited
            ? _c("div", { staticClass: "lh30 flex end-md" }, [
                _c(
                  "a",
                  {
                    staticClass: "cl-tertiary flex",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.edit($event)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "pr5" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("Edit your shipping details")) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "material-icons cl-tertiary" }, [
                      _vm._v("edit")
                    ])
                  ]
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.isEdited
        ? _c(
            "div",
            { staticClass: "row" },
            [
              [
                _c("base-input", {
                  staticClass: "col-xs-12 col-sm-6 mb10",
                  attrs: {
                    type: "text",
                    name: "first-name",
                    autocomplete: "given-name",
                    placeholder: _vm.$t("First name") + " *",
                    validations: [
                      {
                        condition:
                          !_vm.$v.shippingDetails.firstName.required &&
                          _vm.$v.shippingDetails.firstName.$error,
                        text: _vm.$t("Field is required")
                      },
                      {
                        condition: !_vm.$v.shippingDetails.firstName.minLength,
                        text: _vm.$t("Name must have at least 2 letters.")
                      }
                    ]
                  },
                  on: {
                    input: function($event) {
                      return _vm.$v.shippingDetails.firstName.$touch()
                    }
                  },
                  model: {
                    value: _vm.shippingDetails.firstName,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.shippingDetails,
                        "firstName",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "shippingDetails.firstName"
                  }
                }),
                _vm._v(" "),
                _c("base-input", {
                  staticClass: "col-xs-12 col-sm-6 mb10",
                  attrs: {
                    type: "text",
                    name: "last-name",
                    autocomplete: "family-name",
                    placeholder: _vm.$t("Last name") + " *",
                    validations: [
                      {
                        condition:
                          !_vm.$v.shippingDetails.lastName.required &&
                          _vm.$v.shippingDetails.lastName.$error,
                        text: _vm.$t("Field is required")
                      }
                    ]
                  },
                  on: {
                    input: function($event) {
                      return _vm.$v.shippingDetails.lastName.$touch()
                    }
                  },
                  model: {
                    value: _vm.shippingDetails.lastName,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.shippingDetails,
                        "lastName",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "shippingDetails.lastName"
                  }
                }),
                _vm._v(" "),
                _vm.hasBillingAddress()
                  ? _c(
                      "base-checkbox",
                      {
                        staticClass: "col-xs-12 mb10",
                        attrs: { id: "addCompanyFilled" },
                        model: {
                          value: _vm.useCompanyAddress,
                          callback: function($$v) {
                            _vm.useCompanyAddress = $$v
                          },
                          expression: "useCompanyAddress"
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("Use my company's address details")) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("base-input", {
                  staticClass: "col-xs-12 col-sm-6 mb10",
                  attrs: {
                    type: "text",
                    name: "street-address",
                    autocomplete: "address-line1",
                    placeholder: _vm.$t("Street name") + " *",
                    validations: [
                      {
                        condition:
                          !_vm.$v.shippingDetails.street.required &&
                          _vm.$v.shippingDetails.street.$error,
                        text: _vm.$t("Field is required")
                      }
                    ]
                  },
                  on: {
                    input: function($event) {
                      return _vm.$v.shippingDetails.street.$touch()
                    }
                  },
                  model: {
                    value: _vm.shippingDetails.street,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.shippingDetails,
                        "street",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "shippingDetails.street"
                  }
                }),
                _vm._v(" "),
                _c("base-input", {
                  staticClass: "col-xs-12 col-sm-6 mb10",
                  attrs: {
                    type: "text",
                    name: "apartment-number",
                    autocomplete: "address-line2",
                    placeholder: _vm.$t("House/Apartment number") + " *",
                    validations: [
                      {
                        condition:
                          !_vm.$v.shippingDetails.house.required &&
                          _vm.$v.shippingDetails.house.$error,
                        text: _vm.$t("Field is required")
                      }
                    ]
                  },
                  on: {
                    input: function($event) {
                      return _vm.$v.shippingDetails.house.$touch()
                    }
                  },
                  model: {
                    value: _vm.shippingDetails.house,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.shippingDetails,
                        "house",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "shippingDetails.house"
                  }
                }),
                _vm._v(" "),
                _c("base-input", {
                  staticClass: "col-xs-12 col-sm-6 mb10",
                  attrs: {
                    type: "text",
                    name: "city",
                    autocomplete: "address-level2",
                    placeholder: _vm.$t("City") + " *",
                    validations: [
                      {
                        condition:
                          !_vm.$v.shippingDetails.city.required &&
                          _vm.$v.shippingDetails.city.$error,
                        text: _vm.$t("Field is required")
                      },
                      {
                        condition:
                          _vm.$v.shippingDetails.city.$error &&
                          _vm.$v.shippingDetails.city.required,
                        text: _vm.$t("Please provide valid city name")
                      }
                    ]
                  },
                  on: {
                    input: function($event) {
                      return _vm.$v.shippingDetails.city.$touch()
                    }
                  },
                  model: {
                    value: _vm.shippingDetails.city,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.shippingDetails,
                        "city",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "shippingDetails.city"
                  }
                }),
                _vm._v(" "),
                _c("base-input", {
                  staticClass: "col-xs-12 col-sm-6 mb10",
                  attrs: {
                    type: "text",
                    name: "state",
                    autocomplete: "address-level1",
                    placeholder: _vm.$t("State / Province")
                  },
                  model: {
                    value: _vm.shippingDetails.region,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.shippingDetails,
                        "region",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "shippingDetails.region"
                  }
                }),
                _vm._v(" "),
                _c("base-input", {
                  staticClass: "col-xs-12 col-sm-6 mb10",
                  attrs: {
                    type: "text",
                    name: "zip-code",
                    autocomplete: "postal-code",
                    placeholder: _vm.$t("Zip-code") + " *",
                    validations: [
                      {
                        condition:
                          !_vm.$v.shippingDetails.postcode.required &&
                          _vm.$v.shippingDetails.postcode.$error,
                        text: _vm.$t("Field is required")
                      },
                      {
                        condition: !_vm.$v.shippingDetails.postcode.minLength,
                        text: _vm.$t("Zip-code must have at least 3 letters.")
                      }
                    ]
                  },
                  on: {
                    input: function($event) {
                      return _vm.$v.shippingDetails.postcode.$touch()
                    }
                  },
                  model: {
                    value: _vm.shippingDetails.postcode,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.shippingDetails,
                        "postcode",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "shippingDetails.postcode"
                  }
                }),
                _vm._v(" "),
                _c("base-select", {
                  staticClass: "col-xs-12 col-sm-6 mb10",
                  attrs: {
                    name: "countries",
                    options: _vm.countryOptions,
                    selected: _vm.shippingDetails.country,
                    placeholder: _vm.$t("Country *"),
                    validations: [
                      {
                        condition:
                          _vm.$v.shippingDetails.country.$error &&
                          !_vm.$v.shippingDetails.country.required,
                        text: _vm.$t("Field is required")
                      }
                    ],
                    autocomplete: "country-name"
                  },
                  on: {
                    blur: function($event) {
                      return _vm.$v.shippingDetails.country.$touch()
                    },
                    change: function($event) {
                      return _vm.$v.shippingDetails.country.$touch()
                    }
                  },
                  model: {
                    value: _vm.shippingDetails.country,
                    callback: function($$v) {
                      _vm.$set(_vm.shippingDetails, "country", $$v)
                    },
                    expression: "shippingDetails.country"
                  }
                }),
                _vm._v(" "),
                _c("base-input", {
                  staticClass: "col-xs-12 col-sm-6 mb10",
                  attrs: {
                    type: "text",
                    name: "phone-number",
                    autocomplete: "tel",
                    placeholder: _vm.$t("Phone Number")
                  },
                  model: {
                    value: _vm.shippingDetails.phone,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.shippingDetails,
                        "phone",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "shippingDetails.phone"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "hidden-xs col-sm-6 mb25" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c(
                      "button-full",
                      {
                        attrs: { disabled: _vm.$v.$invalid },
                        nativeOn: {
                          click: function($event) {
                            return _vm.updateDetails($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("Update my shipping details")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 flex middle-xs py10" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "h4 cl-accent",
                        attrs: { href: "#" },
                        on: { click: _vm.exitSection }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("Cancel")) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                )
              ]
            ],
            2
          )
        : _c("div", { staticClass: "row fs16 mb35" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 h4" },
              [
                _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.shippingDetails.firstName) +
                      " " +
                      _vm._s(_vm.shippingDetails.lastName) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _vm.useCompanyAddress
                  ? _c(
                      "base-checkbox",
                      {
                        staticClass: "col-xs-12 mb25",
                        attrs: { id: "useCompanyAddressFilled", disabled: "" },
                        model: {
                          value: _vm.useCompanyAddress,
                          callback: function($$v) {
                            _vm.useCompanyAddress = $$v
                          },
                          expression: "useCompanyAddress"
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("Use my company's address details")) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "mb25" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.shippingDetails.company) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb25" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.shippingDetails.street) +
                      "\n        "
                  ),
                  _vm.shippingDetails.house
                    ? _c("span", [
                        _vm._v(" " + _vm._s(_vm.shippingDetails.house))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb25" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.shippingDetails.city) +
                      " " +
                      _vm._s(_vm.shippingDetails.postcode) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb25" }, [
                  _vm.shippingDetails.region
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.shippingDetails.region) + ", ")
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n        " + _vm._s(_vm.getCountryName()) + "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb25" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.shippingDetails.phone) +
                        "\n        "
                    ),
                    _vm.shippingDetails.phone
                      ? _c("tooltip", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("Phone number may be needed by carrier")
                              ) +
                              "\n        "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }